// extracted by mini-css-extract-plugin
export default {"mainImage":"IndividualNews_mainImage__DWDYz","container":"IndividualNews_container__LNU2t"};